export const ASPECT_RATIO = 1 / 1.33;

export const CROP_DEFAULT = { x: 0, y: 0 };
